export default "__VITE_ASSET__gmva96GY__"